<label class="ahe-ui-checkbox" [class.ahe-ui-checkbox_inverted]="inverted">
  <input
    #input
    type="checkbox"
    [attr.aria-label]="ariaLabel"
    [attr.aria-checked]="ariaChecked"
    (change)="_onChangeEvent($event)"
    [attr.disabled]="disabled ? '' : null"
    [attr.required]="required ? '' : null"
    [attr.aria-labelledby]="ariaLabelledBy"
    />
  <span aria-hidden="true"><ng-content></ng-content></span>
  <app-required-indicator [required]="required" [inverted]="inverted"></app-required-indicator>
</label>
